Ext.define('SA.VectorMapExportInsetMapOverlay', {
    alias: 'widget.vector-map-export-inset-map-overlay',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-vector-map-export-overlay sa-vector-map-export-overlay-loading',
    constrain: true,
    draggable: true,
    floating: true,
    height: 100,
    overCls: 'sa-vector-map-export-overlay-over',
    toFrontOnShow: false,
    width: 100,

    resizable: {
        preserveRatio: true,
        transparent: true
    },

    initComponent() {
        this.items = [{
            xtype: 'vector-map-export-inset-map',
            maxExtent: this.model.getMaxExtent(),
            scale: SA.VectorMapConstants.getExportInsetMapExtentScale(),
            style: SA.VectorMapConstants.getInsetMapStyle()
        }];

        this.callParent();

        this.map = this.down('vector-map-export-inset-map');
    },

    initEvents() {
        this.callParent();

        this.map.onLoadingChange(() => this.setLoading(this.map.isLoading() ? 'Loading preview…' : false));
    },

    afterRender() {
        this.callParent();

        this.getEl().addClsOnClick('sa-vector-map-export-overlay-drag');
    },

    getRecord() {
        return this.details.getInsetMap();
    },

    onMouseDown: Ext.emptyFn,

    refresh() {
        if (!this.isVisible()) {
            return;
        }

        var extent = SA.VectorMapExtent.fromXYBounds(this.extent.getBounds());

        this.map.setParams(SA.VectorMapExportParams.forInsetMap({details: this.details, extent, pageWidth: this.page.getWidth()}));
    },

    setLoading(loading) {
        this.callParent(arguments);

        this.ifCls(loading !== false, 'sa-vector-map-export-overlay-loading');
    }
});